import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Spin, Checkbox, Select } from 'antd';
import { Button } from "../../misc/button/Button";
const { TextArea } = Input;

const RequestLaborModificationModal = ({ visible, onCancel, onConfirm, record }) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsSubmitting(false);
      form.resetFields();
    }
  }, [visible, form]);

  const handleSubmit = () => {
    form.validateFields()
      .then(values => {
        setIsSubmitting(true);
        onConfirm(values);
      })
      .catch(error => {
        console.log('Validation failed:', error);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsSubmitting(false);
    onCancel();
  };


  return (
    <Modal
      title="Demande de modification"
      open={visible}
      onCancel={handleCancel}
      destroyOnClose={true}
      footer={null}
    >
      <Spin spinning={isSubmitting} tip="Envoi en cours...">
        <Form
          form={form}
          layout="vertical"
          name="modificationRequestForm"
          initialValues={{
            laborUnion: record?.laborUnion,
            buildingConventionOutside77: record?.buildingConventionOutside77,
          }}
        >
          <Form.Item
            name="laborUnion"
            label= "Adhérent"
            rules={[
              {
                required: true,
                message: 'Veuillez séléctionner une option',
              },
            ]}
          >
            <Select
              placeholder="Sélectionnez un adhérent"
              options={[
                { value: 2, label: "CAPEB" },
                { value: 3, label: "FFB" },
                { value: 1, label: "Aucun" },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="buildingConventionOutside77"
            valuePropName="checked"
          >
            <Checkbox>
              Conventions du Bâtiment hors 77 (case à décocher si l'Adhérent
              est Volontaire ou situé dans le 77)
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="reason"
            label="Motif de la demande de modification"
            rules={[
              {
                required: true,
                message: 'Veuillez indiquer le motif de votre demande de modification',
              },
            ]}
          >
            <TextArea
              placeholder="Décrivez pourquoi vous souhaitez modifier labor adhérent"
              rows={4}
              style={{ resize: 'none' }}
            />
          </Form.Item>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'flex-end',
            gap: '20px',
            marginTop: '20px'
          }}>
            <Button
              onClick={handleCancel}
              children="Annuler"
              style={{marginRight:20}}
            />
            <Button
              onClick={handleSubmit}
              children="Confirmer la demande"
              isDisabled={isSubmitting}
              style={{marginRight:20}}
            />
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default RequestLaborModificationModal;